import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ReservationStore } from '../service/reservation-store';
import { Reservation } from '../models/reservation';

@Injectable()
export class ReservationResolver implements Resolve<any> {
  constructor(private reservationStore: ReservationStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Reservation>> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS'));
    }

    return this.reservationStore.loadReservations(id);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation.resolver.ts